// extracted by mini-css-extract-plugin
module.exports =  {"cell-boolean-container":"CellBoolean-module__cell-boolean-container____a9ts"};